import { render, staticRenderFns } from "./SvgFrontFrameResidenceCertificate.vue?vue&type=template&id=7e7667dd&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports